export default __webpack_public_path__ + "static/broderie13.mobile.inspirations-49f183cda6be257804213e7bdbcfb049.jpg";